// extracted by mini-css-extract-plugin
export default {"root":"d2RYp__root","thumbnail":"OnvNB__thumbnail","timeDisplay":"OAH4C__timeDisplay Z3kBD__controlRoot"};